<script setup>
import { computed, ref } from "vue";
import {__} from "@/helpers";
import { Invitation } from "@/pages/company/members/components/invitation";
import { Invite } from "@/pages/company/members/components/invite/index";

const props = defineProps({
  members: {
    type: Array,
    required: true
  },
  invitations: {
    type: Array,
    required: true
  },
  options: {
    type: Object,
    required: true
  },
  user: {
    type: Object,
    required: true
  },
  role: {
    type: String,
    required: true
  }
});

const emits = defineEmits(['updateInvitedMembers']);

const isRoleCompanyOwner = computed(() => {
  return props.role === 'company_owner';
});

const isRoleCommunityLead = computed(() => {
  return props.role === 'community_lead';
});

const isRoleHrManagement = computed(() => {
  return props.role === 'hr_management';
});


function handleInviteButtonClick(invitation) {
  emits('updateInvitedMembers', invitation)
}

function handleInviteAgainButtonClick(invitation) {
  invitations.value = invitations.value.map((item) => {
    if (item.id === invitation.id) {
      return invitation;
    }

    return item;
  });
}

</script>

<template>
  <Invite
      v-if="isRoleCompanyOwner || isRoleCommunityLead || isRoleHrManagement"
      :members="members"
      :invitations="invitations"
      :options="options"
      @invite="handleInviteButtonClick"
  />

  <div class="overflow-x-auto rounded-lg bg-white shadow-redesign mt-6">
    <table class="w-max min-w-full overflow-x-hidden">
      <thead class="border-b">
      <tr>
        <th class="px-8 py-4 font-medium leading-normal text-zinc-600">
          {{ __('Email') }}
        </th>
        <th class="px-8 py-4 font-medium leading-normal text-zinc-600">
          {{ __('Role') }}
        </th>
        <th class="px-8 py-4 font-medium leading-normal text-zinc-600">
          {{ __('Date') }}
        </th>
        <th
            v-if="isRoleCompanyOwner || isRoleHrManagement"
            class="px-8 py-4 font-medium leading-normal text-zinc-600"
        >
          {{ __('Action') }}
        </th>
      </tr>
      </thead>
      <tbody>
      <Invitation
          v-for="invitation in invitations"
          :key="invitation.id"
          :invitation="invitation"
          :can-edit="isRoleCompanyOwner || isRoleHrManagement "
          @invite-again="handleInviteAgainButtonClick"
      />
      </tbody>
    </table>
  </div>
</template>

<style scoped>

</style>